import React from 'react';
import { useDnD } from './DnDContext';
import useBundleTranslation from 'i18n';
import { useWorkflowContext } from 'app/editor/workflow/context';

export default () => {
    const { t } = useBundleTranslation(['app/admin/editor/generic-workflow/common']);
    const { workflowType } = useWorkflowContext();

    const [type, setType, nodeRole, setNodeRole] = useDnD();

    const onDragStart = (event: React.DragEvent<HTMLDivElement>, nodeType: string, nodeRole: string) => {
        if (null !== setType) setType(nodeType);
        if (null !== setNodeRole) setNodeRole(nodeRole);
        event.dataTransfer.effectAllowed = 'move';
    };

    return (
        <div style={{ width: '200px', height: '300px', display: 'inline-block', verticalAlign: 'top' }}>
            <aside>
                {workflowType == 'concierge_workflow' && (
                    <div
                        className="dndnode input"
                        onDragStart={(event) => onDragStart(event, 'input', 'chat_message')}
                        draggable
                    >
                        {t('chat_message')}
                    </div>
                )}

                {workflowType == 'concierge_workflow' && (
                    <div
                        className="dndnode input"
                        onDragStart={(event) => onDragStart(event, 'default', 'call_search')}
                        draggable
                    >
                        {t('call_search')}
                    </div>
                )}

                {workflowType == 'concierge_workflow' && (
                    <div
                        className="dndnode input"
                        onDragStart={(event) => onDragStart(event, 'default', 'ai_agent')}
                        draggable
                    >
                        {t('ai_agent')}
                    </div>
                )}

                {workflowType == 'concierge_workflow' && (
                    <div
                        className="dndnode input"
                        onDragStart={(event) => onDragStart(event, 'default', 'ai_workflow')}
                        draggable
                    >
                        {t('workflow')}
                    </div>
                )}
            </aside>
        </div>
    );
};
